import { useState, useMemo, useEffect } from "react";
import { TabPane } from "reactstrap";
import { LI, UL } from "../../../../../AbstractElements";
import SentEmailContent from "./SentEmailContent";
import { useNavigate } from "react-router-dom";
import { EmailData } from "../../types";
import CommunicationPagination from "../../../CommunicationPagination";

interface SentContentProps {
  emails: EmailData[];
  emailOpen: string[];
  toggleEmailOpen: (id: string) => void;
  searchWord: string;
}

const SentContent: React.FC<SentContentProps> = ({ emails, searchWord }) => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const filteredEmails = useMemo(
    () =>
      emails.filter(
        (email) =>
          email.recipients.some((recipient) =>
            recipient.toLowerCase().includes(searchWord.toLowerCase())
          ) ||
          email.message.toLowerCase().includes(searchWord.toLowerCase()) ||
          email.subMessage?.toLowerCase().includes(searchWord.toLowerCase())
      ),
    [emails, searchWord]
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchWord]);

  const handleEmailClick = (email: EmailData) => {
    navigate(`${process.env.PUBLIC_URL}/communication/email-details`, {
      state: { email },
    });
  };

  const indexOfLastEmail = currentPage * pageSize;
  const indexOfFirstEmail = indexOfLastEmail - pageSize;
  const currentEmails = filteredEmails.slice(
    indexOfFirstEmail,
    indexOfLastEmail
  );

  return (
    <TabPane tabId="2">
      <>
        <div className="mail-body-wrapper">
          <UL className="simple-list">
            {currentEmails.map((data, i) => (
              <LI
                className="inbox-data"
                key={data.id}
                onClick={() => handleEmailClick(data)}
                style={{ cursor: "pointer" }}
              >
                <SentEmailContent data={data} i={indexOfFirstEmail + i} />
              </LI>
            ))}
          </UL>
        </div>

        <CommunicationPagination
          currentPage={currentPage}
          pageSize={pageSize}
          totalItems={filteredEmails.length}
          onPageChange={setCurrentPage}
        />
      </>
    </TabPane>
  );
};

export default SentContent;
